import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

function ReportHeader({ reportName }) {
  const { t } = useTranslation();
  const auth = useSelector((state) => state?.auth);
  const businessInfo = auth?.buisnessInfo || {};
  const isBusinessLogoOnly = String(businessInfo?.id) === "38";

  return (
    <div className="flex justify-between items-center border-b pb-4 mb-6">
      <div className="text-start w-[25%]">
        <div className="grid grid-cols-1 gap-2 text-sm text-gray-600">
          <div className="flex">
            <span className="font-semibold me-2">{t("License No")}:</span>
            <span>{businessInfo?.licenseNo || "N/A"}</span>
          </div>
          <div className="flex">
            <span className="font-semibold me-2">{t("CR No")}:</span>
            <span>{businessInfo?.crno || "N/A"}</span>
          </div>

          <div className="flex">
            <span className="font-semibold me-2">{t("Phone")}:</span>
            <span>{businessInfo?.phone || "N/A"}</span>
          </div>
          <div className="flex">
            <span className="font-semibold me-2">{t("Email")}:</span>
            <span>{businessInfo?.email || "N/A"}</span>
          </div>
        </div>
      </div>

      <div className="flex flex-col items-center w-[50%]">
        {businessInfo?.logo && (
          <img
            className={`${
              isBusinessLogoOnly ? "h-[7rem]" : "h-[6rem]"
            } mb-2 object-contain`}
            src={`data:image/png;base64,${businessInfo.logo}`}
            alt="Business Logo"
          />
        )}
        {!isBusinessLogoOnly && (
          <>
            <p className="text-red-600 font-bold text-lg text-center">
              {businessInfo?.name_en || t("Business Name")}
            </p>
            <p className="text-red-600 font-bold text-lg text-center mb-1">
              {businessInfo?.name_ar
                ? `(${businessInfo.name_ar})`
                : t("Business Name")}
            </p>
          </>
        )}
        {reportName && (
          <p className="text-gray-600 px-4 py-1 border-t border-gray-200 font-bold text-lg text-center">
            {reportName}
          </p>
        )}
      </div>

      <div className="text-end w-[25%]" dir="rtl">
        <div className="grid grid-cols-1 gap-2 text-sm text-gray-600">
          <div className="flex">
            <span className="font-semibold ms-2">رقم ترخيص:</span>
            <span>{businessInfo?.licenseNo || "N/A"}</span>
          </div>
          <div className="flex">
            <span className="font-semibold ms-2">رقم السجل التجاري:</span>
            <span>{businessInfo?.crno || "N/A"}</span>
          </div>

          <div className="flex">
            <span className="font-semibold ms-2">الهاتف:</span>
            <span>{businessInfo?.phone || "N/A"}</span>
          </div>
          <div className="flex">
            <span className="font-semibold ms-2">البريد الإلكتروني:</span>
            <span>{businessInfo?.email || "N/A"}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportHeader;
